import script from "./BaseChartPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChartPanel.vue?vue&type=script&setup=true&lang=js"

import "./BaseChartPanel.vue?vue&type=style&index=0&id=5d4c6a60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4c6a60"]])

export default __exports__